import { render, staticRenderFns } from "./BankProduct.vue?vue&type=template&id=58f20ae9"
import script from "./BankProduct.vue?vue&type=script&lang=js"
export * from "./BankProduct.vue?vue&type=script&lang=js"
import style0 from "./BankProduct.vue?vue&type=style&index=0&id=58f20ae9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports